import { isSafeHref } from "./safe-href";

/**
 * Scheme gate for an `<img src>`, as distinct from `isSafeHref`'s gate for an
 * href. ⚠ ONE POLICY FOR EVERY IMAGE SINK — three drifted apart once, and the
 * same value rendered in one slot while vanishing from another.
 */
const IMAGE_SCHEMES = ["https:", "http:", "data:"];

const BASE = "https://www.directv.com";

export function isSafeImageSrc(src: unknown): src is string {
  /* Kept after WAT-12420 tightened `isSafeHref` to refuse a blank too: this
     sink states its own rule rather than inheriting one, so a later widening of
     the href gate — where blank is only ever a missing destination — cannot
     quietly put `src=""` back on an <img> and refetch the current page. */
  if (typeof src !== "string" || src.trim() === "") {
    return false;
  }
  if (!isSafeHref(src, IMAGE_SCHEMES)) {
    return false;
  }
  try {
    const url = new URL(src, BASE);
    /* Off the PARSED url: a scheme list cannot express a media type, and the raw
       string can hide the tab the parser strips before reading the scheme. */
    return url.protocol !== "data:" || /^image\//i.test(url.pathname);
  } catch {
    return false;
  }
}
